import "../assets/index-57b305d3.css";
import n from "vue";
import a from "dompurify";
import { n as s } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const i = {
  name: "NcIconSvgWrapper",
  props: {
    /**
     * Raw SVG string to render
     */
    svg: {
      type: String,
      default: ""
    },
    /**
     * Label of the icon, used in aria-label
     */
    name: {
      type: String,
      default: ""
    },
    /**
     * Raw SVG path to render. Takes precedence over the SVG string in the `svg` prop.
     */
    path: {
      type: String,
      default: ""
    }
  },
  computed: {
    cleanSvg() {
      if (!this.svg || this.path)
        return;
      const r = a.sanitize(this.svg), e = new DOMParser().parseFromString(r, "image/svg+xml");
      return e.querySelector("parsererror") ? (n.util.warn("SVG is not valid"), "") : (e.documentElement.id && e.documentElement.removeAttribute("id"), e.documentElement.outerHTML);
    },
    attributes() {
      return {
        class: "icon-vue",
        role: "img",
        "aria-hidden": this.name ? void 0 : !0,
        "aria-label": this.name || void 0
      };
    }
  }
};
var o = function() {
  var e = this, t = e._self._c;
  return e.cleanSvg ? t("span", e._b({ domProps: { innerHTML: e._s(e.cleanSvg) } }, "span", e.attributes, !1)) : t("span", e._b({}, "span", e.attributes, !1), [t("svg", { attrs: { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { d: e.path } })])]);
}, p = [], u = /* @__PURE__ */ s(
  i,
  o,
  p,
  !1,
  null,
  "6176f396",
  null,
  null
);
const v = u.exports;
export {
  v as default
};
